function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 22.25H9C6.3424 22.25 4.56492 21.6803 3.4423 20.5577C2.31968 19.4351 1.75 17.6576 1.75 15V9C1.75 6.3424 2.31968 4.56492 3.4423 3.4423C4.56492 2.31968 6.3424 1.75 9 1.75H15C17.6576 1.75 19.4351 2.31968 20.5577 3.4423C21.6803 4.56492 22.25 6.3424 22.25 9V15C22.25 17.6576 21.6803 19.4351 20.5577 20.5577C19.4351 21.6803 17.6576 22.25 15 22.25ZM9 2.25C6.65972 2.25 4.92432 2.66107 3.7927 3.7927C2.66107 4.92432 2.25 6.65972 2.25 9V15C2.25 17.3403 2.66107 19.0757 3.7927 20.2073C4.92432 21.3389 6.65972 21.75 9 21.75H15C17.3403 21.75 19.0757 21.3389 20.2073 20.2073C21.3389 19.0757 21.75 17.3403 21.75 15V9C21.75 6.65972 21.3389 4.92432 20.2073 3.7927C19.0757 2.66107 17.3403 2.25 15 2.25H9Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 12.25H2C1.86614 12.25 1.75 12.1339 1.75 12C1.75 11.8661 1.86614 11.75 2 11.75H22C22.1339 11.75 22.25 11.8661 22.25 12C22.25 12.1339 22.1339 12.25 22 12.25Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.25 21.75C8.11614 21.75 8 21.6339 8 21.5V12C8 11.8661 8.11614 11.75 8.25 11.75C8.38386 11.75 8.5 11.8661 8.5 12V21.5C8.5 21.6339 8.38386 21.75 8.25 21.75Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 22.25C15.6161 22.25 15.5 22.1339 15.5 22V12C15.5 11.8661 15.6161 11.75 15.75 11.75C15.8839 11.75 16 11.8661 16 12V22C16 22.1339 15.8839 22.25 15.75 22.25Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.25 12.75C7.84 12.75 7.5 12.41 7.5 12V2C7.5 1.59 7.84 1.25 8.25 1.25C8.66 1.25 9 1.59 9 2V12C9 12.41 8.66 12.75 8.25 12.75Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 12.75C15.34 12.75 15 12.41 15 12V2.54C15 2.13 15.34 1.79 15.75 1.79C16.16 1.79 16.5 2.13 16.5 2.54V12C16.5 12.41 16.16 12.75 15.75 12.75Z"
});

function SvgCollections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/collections.d0dfeae0.svg";
export { ForwardRef as ReactComponent };